import React, { useState, useEffect, useRef } from 'react';
import {AboutMe, learningSkills} from '../data/aboutMe';

const About = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id='about' ref={sectionRef} className={`max-w-5xl mx-auto my-12 sm:my-16 px-4 sm:px-6 opacity-0 translate-y-8 transition-all duration-700 w-full ${isVisible ? 'opacity-100 translate-y-0' : ''}`}>
      <div className="mb-8 text-center sm:mb-12">
        <h1 className="mb-2 text-3xl font-bold text-transparent sm:text-4xl bg-gradient-to-r from-primary to-secondary bg-clip-text">About Me</h1>
        <div className="w-16 h-1 mx-auto rounded-full bg-gradient-to-r from-primary to-secondary"></div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-[auto_1fr] gap-4 sm:gap-8 items-center p-4 sm:p-6 bg-white/5 backdrop-blur-sm rounded-2xl shadow-xl border border-white/10">
        <div className="relative w-40 h-40 mx-auto sm:w-48 sm:h-48 md:mx-0">
          <div className="absolute inset-0 rounded-full opacity-75 bg-gradient-to-r from-primary to-secondary animate-spin-slow"></div>
          <img src={AboutMe.profileImage} alt="Profile" className="relative z-10 object-cover w-full h-full border-4 rounded-full shadow-2xl border-dark" />
        </div>
        <div className="text-center md:text-left">
          <h2 className="mb-2 text-2xl font-bold text-transparent sm:text-3xl bg-gradient-to-r from-primary to-secondary bg-clip-text">{AboutMe.name}</h2>
          <p className="mb-3 text-sm text-gray-400 sm:text-base sm:mb-4">Age: {AboutMe.age}</p>
          <p className="text-sm leading-relaxed sm:text-base">{AboutMe.profile}</p>
        </div>
      </div>

      <div id='skills' className="mt-12 sm:mt-16">
        <h2 className="mb-6 text-2xl font-bold text-center text-transparent sm:text-3xl bg-gradient-to-r from-primary to-secondary bg-clip-text sm:mb-8">学習中のスキル</h2>
        <div className="grid grid-cols-4 gap-3 p-3 shadow-xl sm:gap-4 sm:p-4 bg-white/5 backdrop-blur-sm rounded-2xl">
          {learningSkills.map((skill, index) => (
            <div
              key={index}
              className="flex flex-col items-center justify-center gap-2 p-2 sm:p-3 bg-white rounded-xl shadow-md hover:shadow-xl hover:scale-110 transition-all duration-300 cursor-pointer min-h-[70px] sm:min-h-[80px] group"
              title={skill.name}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <img src={skill.icon} alt={skill.name} className="object-contain transition-transform duration-300 w-7 h-7 sm:w-8 sm:h-8 group-hover:scale-125 group-hover:rotate-6" loading="lazy" />
              <span className="text-[10px] sm:text-xs font-semibold text-gray-800 text-center">{skill.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;
